// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"b6ef65ff","237":"e05e6456","703":"a381dd5a","787":"9998ceba"}[chunkId] + ".chunk.js";
};